/**
 * Package size band labels on sell form.
 * Keys: `shipping.band.{CODE}.label` / `shipping.band.{CODE}.help`
 * Admin Label/HelpText remain the fallback for custom bands.
 */

export function shippingSizeBandCode(code: string | null | undefined): string {
    return String(code ?? '').trim().toUpperCase();
}

export function translateShippingSizeBandLabel(
    tr: (key: string, fallback: string) => string,
    code: string | null | undefined,
    adminLabel?: string | null
): string {
    const c = shippingSizeBandCode(code);
    const fallback = (adminLabel ?? '').trim() || c;
    if (!c) return fallback;
    return tr(`shipping.band.${c}.label`, fallback);
}

export function translateShippingSizeBandHelp(
    tr: (key: string, fallback: string) => string,
    code: string | null | undefined,
    adminHelp?: string | null
): string {
    const c = shippingSizeBandCode(code);
    const fallback = (adminHelp ?? '').trim();
    if (!c) return fallback;
    return tr(`shipping.band.${c}.help`, fallback);
}
